import AgencySaleAddOrderScreen from 'features/Agency/screens/AgencySaleAddOrderScreen';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import VoucherPartnerDetailScreen from './screens/VoucherPartnerDetailScreen';
import AgencySaleDetailScreen from 'features/Agency/screens/AgencySaleDetailScreen';
import EditAgencyScreen from 'features/ManageDealer/screens/EditAgencyScreen';
import VoucherPartnerListScreen from './screens/VoucherPartnerListScreen';

function VoucherPartner(props) {
    const { isVoucherPartnerInfo } = props;
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0 pb-4">
                <Routes>
                    <Route path="" element={<VoucherPartnerListScreen />} />
                    <Route
                        path={"/add"}
                        element={<EditAgencyScreen agencyRole="VOUCHER_PARTNER" />}
                    />
                    <Route path="/:agencyId" element={<VoucherPartnerDetailScreen isVoucherPartnerInfo={isVoucherPartnerInfo} />} />
                    <Route
                        path={"/:agencyId/edit"}
                        element={<EditAgencyScreen agencyRole="VOUCHER_PARTNER" isEditUserAgency={true} />}
                    />
                    {/* <Route path="/:agencyId/sale/:saleId" element={<AgencySaleDetailScreen />} />
                    <Route path="/:agencyId/:saleId" element={<AgencySaleDetailScreen />} />
                    <Route path="/coinvestor-info/:agencyId" element={<VoucherPartnerDetailScreen />} />
                    <Route path="/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
                    <Route path="/:agencyId/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} /> */}
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default VoucherPartner;
